<template>
  <div>
    <a-modal
      :visible="visible"
      :footer="null"
      :closable="false"
      :width="920"
      :mask-closable="true"
      wrap-class-name="country-address-modal-wrap"
      centered
      @cancel="visible = false"
    >
      <div class="country-address-wrap">
        <div class="country-address-main">
          <div class="country-address-header align-center">
            <img src="~/assets/home/location.svg" class="header-icon" alt="" />
            <span class="header-title">{{ $t('home.country_address_modal_title') }}</span>
          </div>
          <div class="country-list">
            <div v-for="(country, index) in countryAddressList" :key="index" class="country-card">
              <div class="country-card-header align-center">
                <img v-if="country.flag" :src="country.flag" class="country-flag" alt="" />
                <span class="country-name">{{ country.name }}</span>
              </div>
              <div v-for="(addr, addrIndex) in country.addresses" :key="addrIndex" class="address-item align-center">
                <img src="~/assets/detail/map.svg" class="address-icon" alt="" />
                <span class="address-text">
                  <span class="address-city">{{ addr.city }}</span>
                  <span class="address-divider">|</span>
                  <span class="address-detail">{{ addr.detail }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="country-address-side">
          <img src="~/assets/close.svg" class="close-btn" alt="" @click="visible = false" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { groupAddressList } from '~/utils/countryAddress'

export default {
  name: 'CountryAddress',
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    countryAddressList() {
      return groupAddressList(this.$store.state.addressList)
    },
  },
  methods: {
    show() {
      this.visible = true
    },
  },
}
</script>

<style lang="less" scoped>
.country-address-wrap {
  display: flex;
  min-height: 560px;
}

.country-address-main {
  flex: 1;
  min-width: 0;
  padding: 32px 28px 32px 32px;
  background: #fff;
}

.country-address-header {
  margin-bottom: 24px;

  .header-icon {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }

  .header-title {
    font-size: 20px;
    font-weight: 600;
    color: #232c46;
    line-height: 28px;
  }
}

.country-list {
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
  }
}

.country-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px 20px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.country-card-header {
  margin-bottom: 12px;

  .country-flag {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .country-name {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    line-height: 22px;
  }
}

.address-item {
  align-items: flex-start;
  margin-top: 10px;

  &:first-of-type {
    margin-top: 0;
  }

  .address-icon {
    width: 14px;
    height: 14px;
    margin-top: 3px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .address-text {
    font-size: 14px;
    color: #727272;
    line-height: 20px;
    word-break: break-word;
  }

  .address-city {
    color: #727272;
  }

  .address-divider {
    margin: 0 8px;
    color: #727272;
  }

  .address-detail {
    color: #727272;
  }
}

.country-address-side {
  position: relative;
  width: 280px;
  flex-shrink: 0;
  overflow: hidden;
  background-image: url('~/assets/map.jpg');
  background-repeat: no-repeat;
  background-size: cover;

  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 2;
  }
}
</style>

<style lang="less">
.country-address-modal-wrap {
  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-modal-body {
    padding: 0 !important;
  }
}
</style>
